import type { DocEntry } from "@manifest/schema.ts";

const SHANNONS_PER_CKB = 100_000_000n;

export function CellMetaHeader({ doc }: { doc: DocEntry }) {
  const capacityCkb = (BigInt(doc.ckbfs.capacity) / SHANNONS_PER_CKB).toString();
  const txShort = `${doc.ckbfs.tx_hash.slice(0, 10)}…${doc.ckbfs.tx_hash.slice(-8)}`;
  const explorerUrl = `https://testnet.explorer.nervos.org/transaction/${doc.ckbfs.tx_hash}`;
  return (
    <div className="text-xs text-parchment-700 font-mono mb-6 pb-4 border-b border-parchment-400/60">
      reading{" "}
      <a
        href={explorerUrl}
        target="_blank"
        rel="noreferrer"
        className="text-parchment-800 underline decoration-parchment-400 hover:decoration-parchment-700"
      >
        {txShort}
      </a>{" "}
      · v{doc.version} · {capacityCkb} CKB locked · {doc.license}
    </div>
  );
}
